export default "__VITE_PUBLIC_ASSET__b7363d93__"